export enum ProjectActionTypeEnum {
  VIEW = 'view',
  EDIT = 'edit',
  QUOTE_COST = 'quote-cost'
}
